import React from 'react';
import { InputAdornment } from '@material-ui/core';
import { CheckCircle, Error } from '@material-ui/icons';
import PropTypes from 'prop-types';

export default function TextFieldStatus({ error, value }) {
  if (error) {
    return (
      <InputAdornment position="end">
        <Error style={{ width: '18px', height: '18px' }} color="error" />
      </InputAdornment>
    );
  }
  if (!error && value) {
    return (
      <InputAdornment position="end" style={{ color: '#4FA050' }}>
        <CheckCircle style={{ width: '18px', height: '18px' }} color="inherit" />
      </InputAdornment>
    );
  }
  return null;
}
TextFieldStatus.defaultProps = {
  error: null,
  value: null,
};
TextFieldStatus.propTypes = {
  error: PropTypes.string,
  value: PropTypes.string,
};
